import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubmitCard from "./sections/filogix-submit/submit-card.vue";
import DealsCard from "./sections/filogix-deals/deals-card.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { LOAD_LENDERS } from "../../../store/lender-submit-actions";
import { LOAD_FILOGIX_SUBMISSIONS } from "../../../store/application-actions";
import FilogixLoader from "./filogix-loader.vue";
import { IS_APPLICATION_SYNCABLE } from "../../../store/application-getters";
import ApplicationSyncStatus from "./sections/expert-sync-application/sync-status.vue";
import ApplicationSyncHistory from "./sections/expert-sync-application/sync-history.vue";
import FilogixNavigation from "./filogix-navigation.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FilogixContainer",
  title() {
    return this.$t("sidebar.sections.application.filogix");
  },
  components: {
    SubmitCard,
    DealsCard,
    FilogixLoader,
    ApplicationSyncStatus,
    ApplicationSyncHistory,
    FilogixNavigation
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      page: "submit-to-filogix"
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [IS_APPLICATION_SYNCABLE])), mapState("ApplicationStore", {
    loadingSyncStatus(state) {
      var _state$filogix$updati, _state$filogix$updati2;
      return (_state$filogix$updati = (_state$filogix$updati2 = state.filogix.updatingSyncStatus.byApplication[this.applicationId]) == null ? void 0 : _state$filogix$updati2.loading) != null ? _state$filogix$updati : false;
    }
  })),
  async mounted() {
    if (this.IS_APPLICATION_SYNCABLE(this.applicationId)) {
      this.page = "automatic-sync";
      return;
    }
    this.loading = true;
    await this.LOAD_LENDERS({
      applicationId: this.applicationId
    });
    await this.LOAD_FILOGIX_SUBMISSIONS({
      applicationId: this.applicationId,
      clientUsername: this.clientUsername
    });
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_LENDERS, LOAD_FILOGIX_SUBMISSIONS])), {}, {
    handlePageChange(page) {
      this.page = page;
    },
    handleUpdateSyncStatus(event) {
      this.$root.$emit("update-sync-status", event);
    }
  })
});